import React, { Fragment, useState } from 'react';

import { TrashIcon } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import GptPopupRemove from '../GptPopupRemove';

export default function GptListItem({
    gpt
}) {

    const [ removePopup, setRemovePopup ] = useState(false);


    const removePopupHandler = (e) => {
        e.preventDefault();
        setRemovePopup(true);
    }

    return (
        <Fragment>
            <Link to={`/settings/gpts/${gpt._id}`} className='border-b last:border-0 border-light hover:bg-verylight flex items-center gap-4 p-4'>
                <div className='flex-4'>
                    <p className='font-semibold'>{gpt.name}</p>
                    <p className='text-sm text-muted'>{gpt.slug}</p>
                </div>
                <div className='flex-2'>
                    <p className='text-sm text-muted'>{gpt.enabled ? "Enabled" : "Disabled"}</p>
                </div>
                <div className='flex-1 flex items-center justify-end gap-4'>
                    <div className='' onClick={removePopupHandler}>
                        <TrashIcon size={20} className='inline-block mb-1' />
                    </div>
                </div>
            </Link>
            <GptPopupRemove
                visible={removePopup}
                setVisible={setRemovePopup}
                gpt={gpt}
            />
        </Fragment>
    )
}
